/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreNrsCreateAliases {
  AUTOCOMPLETE_DISEASE_SEVERITY_DOMAIN = 'autocomplete-disease-severity-domain',
  AUTOCOMPLETE_NUTRITIONAL_STATUS_DOMAIN = 'autocomplete-nutritional-status-domain',
  CHECKBOX_IE_WEIGHT_LOSS = 'checkbox-ie-weight-loss',
  CHECKBOX_REDUCED_FEEDING = 'checkbox-reduced-feeding',
  CHECKBOX_UTI = 'checkbox-uti',
  FETCH_DISEASE_SEVERITY_DOMAIN = 'fetch-disease-severity-domain',
  FETCH_NUTRITIONAL_STATUS_DOMAIN = 'fetch-nutritional-status-domain',
  FIELD_AGE = 'field-age',
  FIELD_DISEASE_SEVERITY_DOMAIN = 'field-disease-severity-domain',
  FIELD_EVALUATION_DATE = 'field-evaluation-date',
  FIELD_HEIGHT = 'field-height',
  FIELD_IE_WEIGHT_LOSS = 'field-ie-weight-loss',
  FIELD_IMC = 'field-imc',
  FIELD_NOTE = 'field-note',
  FIELD_NUTRITIONAL_STATUS_DOMAIN = 'field-nutritional-status-domain',
  FIELD_REDUCED_FEEDING = 'field-reduced-feeding',
  FIELD_USUAL_WEIGHT = 'field-usual-weight',
  FIELD_UTI = 'field-uti',
  FIELD_WEIGHT = 'field-weight',
  FIELD_WEIGHT_LOSS = 'field-weight-loss',
  FORM_CONTEXTUAL_BAR = 'form-contextual-bar',
  FORM_SCORE_NRS_CREATE = 'form-score-nrs-create',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_AGE = 'input-age',
  INPUT_EVALUATION_DATE = 'input-evaluation-date',
  INPUT_HEIGHT = 'input-height',
  INPUT_IMC = 'input-imc',
  INPUT_NOTE = 'input-note',
  INPUT_USUAL_WEIGHT = 'input-usual-weight',
  INPUT_WEIGHT = 'input-weight',
  INPUT_WEIGHT_LOSS = 'input-weight-loss',
  MAPPER_DISEASE_SEVERITY_DOMAIN = 'mapper-disease-severity-domain',
  MAPPER_NUTRITIONAL_STATUS_DOMAIN = 'mapper-nutritional-status-domain',
  PANEL_BODY = 'panel-body',
  PANEL_SCORE_NRS_CREATE = 'panel-score-nrs-create',
  SCORE_NRS_ADD_LAYOUT = 'score-nrs-add-layout',
  TEXT_DISEASE_SEVERITY_DOMAIN = 'text-disease-severity-domain',
  TEXT_NUTRITIONAL_STATUS_DOMAIN = 'text-nutritional-status-domain',
}
export { ScoreNrsCreateAliases };
